<template>
  <v-app id="fdi-app">
    <v-content id="app-container">
      <router-view v-if="setupAndPreloadingComplete"></router-view>

      <v-snackbar
        vertical
        :value="downloadingTour"
        top
        color="black"
        auto-height
      >
        <p class="bebas subheading">
          Downloading Edible Mystery Tour from FDI Headquarters
        </p>
        <p class="prestige">Please Wait a Moment ...</p>
        <v-flex d-flex justify-middle align-center>
          <v-progress-circular
            :width="4"
            size="75"
            color="red"
            indeterminate
          ></v-progress-circular>
        </v-flex>
      </v-snackbar>
    </v-content>

    <!-- <onboarding-component :open="!downloadingTour && onboardingDialog" /> -->
    <demo-request :open="!downloadingTour && demoRequestDialog" />
    <faqs-component :open="faqsDialog" />
    <credits-component :open="creditsDialog" />
    <troubleshooting :open="tsDialog" />

    <bottom-nav />
    <!-- <landscape-error :open="landscapeOpen"/> -->
  </v-app>
</template>

<script>
import BottomNav from './components/BottomNav2.vue'
import FaqsComponent from './components/FAQ.vue'
import TourCountdown from './components/TourCountdown.vue'
import VueCountdown from '@xkeshi/vue-countdown'
import CreditsComponent from './components/Credits.vue'
import Store from '@/store'
import onboardingComponent from '@/components/Onboarding.vue'
import demoRequestComponent from '@/components/DemoRequest.vue'
import Troubleshooting from '@/components/Troubleshooting.vue'
import LandscapeError from '@/components/LandscapeError.vue'
import { setTimeout } from 'timers'

export default {
  name: 'fdiApp',
  components: {
    'landscape-error': LandscapeError,
    'bottom-nav': BottomNav,
    countdown: VueCountdown,
    'tour-countdown': TourCountdown,
    'faqs-component': FaqsComponent,
    'credits-component': CreditsComponent,
    'onboarding-component': onboardingComponent,
    'demo-request': demoRequestComponent,
    troubleshooting: Troubleshooting,
  },
  data() {
    return {
      screenRequestOpen: true,
      secondsToStart: '',
      testingImageUrl: '',
      athsDialog: false,
      timeout: 0,
      downloadingTour: false,
    }
  },
  methods: {
    async downloadAndSetupTour(serviceWorkerAvailable) {
      this.downloadingTour = true
      let that = this
      var user = this.localUser
      var version = user['custom:tourVersion'] ? user['custom:tourVersion'] : 1
      var tourAbbrv = user['custom:tourAbbrv'].toLowerCase()
      if (tourAbbrv.indexOf('-') > -1) {
        tourAbbrv = tourAbbrv.split('-').join('_')
      }
      try {
        await this.$store.dispatch('fetchAllTours', {
          tourAbbrv: tourAbbrv,
          version: version,
          serviceWorker: serviceWorkerAvailable,
        })
        await this.$store.dispatch('setupTour')
        return
      } catch (err) {
        return err
      }
    },
    async init() {
      console.log('initializing')
      if (this.localUser) {
        console.log('found local user')
        if (this.setupFinished) {
          console.log('setup not finished, must watch for change')
          return
        }
        if (!this.serviceWorkerAvailable) {
          this.downloadAndSetupTour(false)
        } else {
          if (this.serviceWorkerActivated) {
            this.downloadAndSetupTour(true)
          } else {
            if ('development' === 'development') {
              await this.downloadAndSetupTour(false)
            }
          }
        }
      }
    },
  },
  watch: {
    localUser: function (newData, oldData) {},
    serviceWorkerActivated: async function (newData, oldData) {
      console.log(
        'Data Change for serviceWorkerActivated Watcher',
        newData,
        oldData
      )
      if (newData) {
        this.downloadAndSetupTour(true)
      } else {
        console.log('but condition not met')
      }
    },
    setupFinished: function (newData, oldData) {
      console.log('Data change for setupFinished Watcher', newData, oldData)
      if (
        newData &&
        this.serviceWorkerActivated &&
        !this.setupAndPreloadingComplete
      ) {
        console.log(
          'condition met, dispatching preload in setupFinished watcher'
        )
        this.$store.dispatch('preloadAllTourData')
        // } else if (newData && this.setupAndPreloadingComplete) {
        //   this.downloadingTour = false
        // } else if (newData && !this.serviceWorkerAvailable) {
        //   console.log('service worker not available and setup complete')
        //   this.downloadingTour = false
        // } else if (newData) {
        //   this.downloadingTour = false
      } else {
        this.downloadingTour = false
        this.$store.dispatch('finishSetupAndPreloading')
      }
    },
    preloadImagesSuccess: function (newData, oldData) {
      //console.log('Data change in preloadImagesSuccess Watcher')
      if (newData) {
        this.downloadingTour = false
        this.$store.dispatch('finishSetupAndPreloading')
      }
    },
  },
  computed: {
    // orientationAngle() {
    //   return this.$store.getters.orientationAngle;
    // },
    currentStepType() {
      return 10
    },
    // landscapeOpen() {
    //   return this.orientationAngle === 90 || this.orientationAngle === 180;
    // },
    localUser() {
      return this.$store.getters.localUser
    },
    setupAndPreloadingComplete() {
      return this.$store.getters.setupAndPreloadingComplete
    },
    tsDialog() {
      return this.$store.getters.tsDialog
    },
    serviceWorkerActivated() {
      return this.$store.getters.serviceWorkerActivated
    },
    serviceWorkerAvailable() {
      return this.$store.getters.serviceWorkerAvailable
    },
    demoRequestDialog() {
      return this.$store.getters.demoRequest
    },
    preloadingImages(val) {
      return this.$store.getters.preloadingImages
    },
    preloadImagesSuccess() {
      return this.$store.getters.preloadImagesSuccess
    },
    onboardingDialog() {
      return this.$store.getters.onboarding
    },
    isUserTourAvailable() {
      return this.$store.getters.isUserTourAvailable
    },
    setupFinished() {
      return this.$store.getters.setupFinished
    },
    faqsDialog() {
      return this.$store.getters.faqDialog
    },
    creditsDialog() {
      return this.$store.getters.creditsDialog
    },
    deferredPrompt() {
      return this.$store.getters.deferredPrompt
    },
  },
  async created() {},
  async mounted() {
    this.init()
    this.$store.dispatch('setOrientationAngle', screen.orientation.angle)
    window.addEventListener('orientationchange', () => {
      console.log(
        'the orientation of the device is now ' + screen.orientation.angle
      )
      this.$store.dispatch('setOrientationAngle', screen.orientation.angle)
    })
  },
}
</script>

<style>
#fdi-app {
  height: 100%;
  width: 100%;
  background-image: url('./assets/paper_bkgd.png');
  background-size: cover;
  background-position: center;
}

#onboarding-stepper {
  background-color: black;
  color: white;
  border-radius: 15px;
}

#countdown-container {
  font-family: 'BebasNeue-Regular';
  font-size: 36px;
  position: absolute;
  top: 100px;
  bottom: auto;
}

#app-container {
  height: 100%;
  width: 100%;
  position: relative;
}

#screenfull-dialog {
  position: absolute;
  bottom: 100px;
}

.button-border {
  border: 3px solid white;
  border-radius: 5px;
  font-size: 20px;
}

.button-border-beige {
  border: 3px solid#D6B682;
  border-radius: 5px;
  font-size: 20px;
}
.button-border-beige-sm {
  border: 3px solid#D6B682;
  border-radius: 5px;
  font-size: 16px;
}
.button-border-2 {
  border: 3px solid black;
  border-radius: 5px;
  font-size: 20px;
}

.modal-class {
  height: 100%;
}

.fdi-quiz-modal {
  height: 425px;
  border-radius: 15px;
}

.fdi-help-modal {
  height: 400px;
  border-radius: 15px;
}

.modal-actions {
  position: absolute;
  width: 100%;
  bottom: 10px;
}

.border-radius-5 {
  border-radius: 5px;
}

.border-radius-15 {
  border-radius: 15px;
}

.fs-16 {
  font-size: 16px;
}

.fs-18 {
  font-size: 18px;
}

.fs-20 {
  font-size: 20px;
}

.fs-24 {
  font-size: 24px;
}

.fs-36 {
  font-size: 36px;
}

.fs-em {
  font-size: 0.7em;
}

.fdi-red--text {
  color: #ae250a;
}
</style>
